import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AccountService } from './account.service';
import { CodelistTranslationService } from 'projects/einvoice-viewer/src/lib/services/codelist-translation.service';
//import { CodelistTranslationService } from 'einvoice-viewer';

@Injectable({
  providedIn: 'root',
})
export class AppService {

  public applicationReady: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public titleChanged: BehaviorSubject<string> = new BehaviorSubject<string>($localize`:@@einvoice.app.title:e-invoice viewer`);

  constructor(
    private codelistTranslationService: CodelistTranslationService,
    private accountService: AccountService
  ) {
    this.codelistTranslationService.loadCodelistTranslations(this.accountService.Locale);
  }

  public setTitle(title: string): void {
    this.titleChanged.next(title);
  }
}
